
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terminal/prices",
      function () {
        return require("private-next-pages/terminal/prices.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terminal/prices"])
      });
    }
  